import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Select,
  SimpleGrid,
  Stack,
  Text,
  Textarea,
} from '@chakra-ui/react';
import axiosInstance from '../../../api/AxiosInstance';

interface Props {
  modo: 'new' | 'view';
  data?: any;
  onGuardado?: () => void;
  onCancelar?: () => void;
}

const FormularioCapacitacion: React.FC<Props> = ({ modo, data, onGuardado, onCancelar }) => {
  const [form, setForm] = useState<any>({
    nombre: '',
    tipo: '',
    instructor: '',
    lugar: '',
    fechaHora: '',
    cupo: '',
    descripcion: '',
    estatus: 'activo',
  });
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    if (data) {
      setForm({
        nombre: data.nombre || '',
        tipo: data.tipo || '',
        instructor: data.instructor || '',
        lugar: data.lugar || '',
        fechaHora: data.fechaHora ? new Date(data.fechaHora).toISOString().slice(0, 16) : '',
        cupo: data.cupo ?? '',
        descripcion: data.descripcion || '',
        estatus: data.estatus || 'activo',
      });
    }
  }, [data]);

  const handleChange = (field: string, value: any) => {
    setForm((prev: any) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    if (!form.nombre || !form.fechaHora) return;
    setGuardando(true);
    try {
      if (modo === 'new') {
        await axiosInstance.post('/turismo/capacitaciones', form);
      }
      onGuardado && onGuardado();
    } finally {
      setGuardando(false);
    }
  };

  const disabled = modo === 'view';

  return (
    <Box>
      <Stack spacing={5}>
        <Box borderWidth="1px" borderRadius="lg" p={4} bg="#f7efe8">
          <Text fontWeight="bold" color="#5b182b" mb={3}>Datos de la capacitación</Text>
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
            <FormControl isRequired>
              <FormLabel>Nombre</FormLabel>
              <Input value={form.nombre} onChange={(e) => handleChange('nombre', e.target.value)} isDisabled={disabled} />
            </FormControl>
            <FormControl>
              <FormLabel>Tipo</FormLabel>
              <Input value={form.tipo} onChange={(e) => handleChange('tipo', e.target.value)} isDisabled={disabled} />
            </FormControl>
            <FormControl>
              <FormLabel>Instructor</FormLabel>
              <Input value={form.instructor} onChange={(e) => handleChange('instructor', e.target.value)} isDisabled={disabled} />
            </FormControl>
            <FormControl>
              <FormLabel>Lugar</FormLabel>
              <Input value={form.lugar} onChange={(e) => handleChange('lugar', e.target.value)} isDisabled={disabled} />
            </FormControl>
            <FormControl>
              <FormLabel>Cupo</FormLabel>
              <Input type="number" value={form.cupo} onChange={(e) => handleChange('cupo', e.target.value)} isDisabled={disabled} />
            </FormControl>
            <FormControl>
              <FormLabel>Estatus</FormLabel>
              <Select value={form.estatus} onChange={(e) => handleChange('estatus', e.target.value)} isDisabled={disabled}>
                <option value="activo">Activo</option>
                <option value="concluido">Concluido</option>
              </Select>
            </FormControl>
          </SimpleGrid>
        </Box>

        <Box borderWidth="1px" borderRadius="lg" p={4}>
          <Text fontWeight="bold" color="#5b182b" mb={3}>Agenda</Text>
          <HStack align="end" spacing={4} flexWrap="wrap">
            <FormControl isRequired minW={{ base: '100%', md: '320px' }}>
              <FormLabel>Fecha y hora programada</FormLabel>
              <Input type="datetime-local" value={form.fechaHora} onChange={(e) => handleChange('fechaHora', e.target.value)} isDisabled={disabled} />
            </FormControl>
          </HStack>
        </Box>

        <Box borderWidth="1px" borderRadius="lg" p={4} bg="gray.50">
          <Text fontWeight="bold" color="#5b182b" mb={3}>Descripción</Text>
          <FormControl>
            <FormLabel>Detalle</FormLabel>
            <Textarea value={form.descripcion} onChange={(e) => handleChange('descripcion', e.target.value)} isDisabled={disabled} rows={4} />
          </FormControl>
        </Box>
      </Stack>

      {modo !== 'view' && (
        <Box mt={6} display="flex" gap={3} justifyContent="flex-end">
          <Button onClick={onCancelar} variant="outline">Cancelar</Button>
          <Button bg="#5b182b" color="white" _hover={{ bg: '#691f30' }} onClick={handleSubmit} isLoading={guardando} loadingText="Guardando">Guardar</Button>
        </Box>
      )}
    </Box>
  );
};

export default FormularioCapacitacion;
